export default __webpack_public_path__ + "static/media/release6.c5d2435e.jpeg";